
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResistor3 as ObiResistor3Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-resistor-3.js';
 
 
 

 
 export const ObiResistor3 = createComponent({
   react: React,
   tagName: 'obi-resistor-3',
   elementClass: ObiResistor3Element,
   events: {
     
   }
  });
 
 